// A slim strip across the top of every board on a Render PR preview, so a screenshot of the
// v2 preview is never mistaken for production. Reads the shared `['me']` query, which the
// landing redirect and the admin console already fetch, so it costs no extra round trip there.

import { useQuery } from '@tanstack/react-query';
import { fetchMe } from '../api/client';
import { useAuthContext } from '../auth/AuthContext';
import { PREVIEW_BANNER_TEXT, showsPreviewBanner } from '../lib/preview';

export function PreviewBanner() {
  const { getToken } = useAuthContext();
  const meQuery = useQuery({ queryKey: ['me'], queryFn: () => fetchMe(getToken) });

  if (!showsPreviewBanner(meQuery.data)) return null;
  return (
    <div className="previewbanner" role="status">
      {PREVIEW_BANNER_TEXT}
    </div>
  );
}
